import { Notification, NotificationTypeEnum } from '../../models';
import { GeneralSettingsData } from '../../models';
import moment from 'moment';
import { DateRangeSelectorState } from '../../components/DateRangeSelector';
import { serviceName } from '../../shared/appointmint/appointment';
import { parseCurrencyValue } from '../../shared/currency';

export interface DebtRow {
    notification: Notification;
    amount: number;
    month: string;
    serviceLabel: string;
}

export const buildDebtRows = (notifications: Notification[], generalSettings: GeneralSettingsData): DebtRow[] =>
    notifications.map(notification => ({
        notification,
        amount: parseCurrencyValue(notification.value),
        month: notification.date.substring(0, 7),
        serviceLabel: notification.type === NotificationTypeEnum.AppointmentMissingPayment && notification.serviceType
            ? serviceName(notification.serviceType, generalSettings)
            : (notification.serviceType ?? ''),
    }));

export const buildDefaultDebtDateRange = (): DateRangeSelectorState => ({
    from: moment().subtract(6, 'months').format('YYYY-MM-DD'),
    to: moment().format('YYYY-MM-DD'),
    type: 'range',
});
